module.exports = __webpack_public_path__ + "img/PG.0e74114a.png";